import React, { useState } from 'react'
import developer from '../../images/ApiTransformer.png'
import support from '../../images/SupportButton.png'
import { useLocation } from '@gatsbyjs/reach-router'
import { HeadingText } from '@paypalcorp/pp-react'

const Header = () => {
  const location = useLocation()
  const currentPath = location.pathname
  const MAPPING_PATH = '/tools/limited/api-transformer/mapping/'
  const CONVERTER_PATH = '/tools/limited/api-transformer/converter/'
  const DEFAULT_PATH = '/tools/limited/api-transformer/'

  const [tab, setTab] = useState(currentPath)

  const [hover, setHover] = useState(false)
  const linkStyle = {
    paddingBottom: '10px',
    borderBottom: hover ? '5px solid #003087' : '5px solid transparent',
    color: hover ? '#003087' : 'black',
    textDecoration: 'none',
    display: 'inline-block',
  }

  const [hover2, setHover2] = useState(false)
  const linkStyle2 = {
    paddingBottom: '10px',
    borderBottom: hover2 ? '5px solid #003087' : '5px solid transparent',
    color: hover2 ? '#003087' : 'black',
    textDecoration: 'none',
    display: 'inline-block',
  }

  const handleTabClick = (input) => {
    setTab(input)
  }

  return (
    <div style={{ backgroundColor: 'white' }}>
      <header
        style={{
          display: 'flex',
          paddingLeft: '50px',
          paddingTop: '10px',
          paddingBottom: '15px',
        }}
      >
        <span style={{ marginTop: '10px' }}>
          <img
            src={developer}
            style={{ height: '50px' }}
            alt="paypal-mark-monotone-transparent"
          />
        </span>

        <div
          style={{
            marginTop: '20px',
            marginLeft: '4%',
            width: '70%',
            display: 'flex',
          }}
        >
          <span style={{ marginLeft: '5%' }}>
            <a
              onClick={() => handleTabClick(MAPPING_PATH)}
              onMouseEnter={() => setHover(true)}
              onMouseLeave={() => setHover(false)}
              href={MAPPING_PATH}
              style={{
                ...linkStyle,
                fontWeight:
                  tab === MAPPING_PATH || tab === DEFAULT_PATH
                    ? 'bold'
                    : 'normal',
                fontSize: '22px',
                cursor: 'pointer',
              }}
            >
              <HeadingText
                size="sm"
                style={{
                  fontWeight:
                    tab === MAPPING_PATH || tab === DEFAULT_PATH
                      ? 'bold'
                      : 'normal',
                }}
              >
                Parameter Mapping
              </HeadingText>
            </a>
          </span>
          <span style={{ marginLeft: '5%' }}>
            <a
              onClick={() => handleTabClick(CONVERTER_PATH)}
              onMouseEnter={() => setHover2(true)}
              onMouseLeave={() => setHover2(false)}
              href={CONVERTER_PATH}
              style={{
                ...linkStyle2,
                fontWeight: tab === CONVERTER_PATH ? 'bold' : 'normal',
                fontSize: '22px',
                cursor: 'pointer',
                textDecoration: 'none',
              }}
            >
              <HeadingText
                size="sm"
                style={{
                  fontWeight: tab === CONVERTER_PATH ? 'bold' : 'normal',
                }}
              >
                API Converter
              </HeadingText>
            </a>
          </span>
        </div>

        <a
          href="https://www.paypal-support.com/s/?language=en_US"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: 'flex',
            alignItems: 'center',
            textDecoration: 'none',
          }}
        >
          <span
            style={{ marginTop: '10px', display: 'flex', alignItems: 'center' }}
          >
            <img
              src={support}
              style={{ height: '50px' }}
              alt="paypal-mark-monotone-transparent"
            />
            <span style={{ marginLeft: '10px', color: 'blue' }}>
              Technical Questions
            </span>
          </span>
        </a>
      </header>
    </div>
  )
}

export default Header
